import { z } from 'zod';

export const PlannerImportLogCategorySchema = z.enum([
  'skipped_no_id',
  'skipped_duplicate',
  'multi_id_row',
  'pl_manager_mismatch_unresolved',
  'missing_manager_tag',
  'qs_mit_bl_review',
  'blocked_review',
  'out_of_segment_scope',
  'sync_error',
  // #123: Quelle wurde beim Auftrag-Verschieben zusammengeführt statt gelöscht.
  'zusammengefuehrt',
]);
export type PlannerImportLogCategory = z.infer<typeof PlannerImportLogCategorySchema>;

export const PlannerImportLogEntrySchema = z.object({
  row_ref: z.string().nullable(),
  salesforce_id: z.string().nullable(),
  category: PlannerImportLogCategorySchema,
  message: z.string(),
});
export type PlannerImportLogEntry = z.infer<typeof PlannerImportLogEntrySchema>;

export const PlannerImportChangeSchema = z.object({
  salesforce_id: z.string(),
  row_ref: z.string(),
  target_phase_name: z.string(),
  due_date: z.string().nullable(),
  manager_tag_name: z.string().nullable(),
  comment_body: z.string().nullable(),
  set_qs_with_bl: z.boolean(),
  set_blocked: z.boolean(),
  secondary_salesforce_ids: z.array(z.string()),
  // Aufgelöste Planner-„Zugewiesen an"-E-Mails (Zuständigkeits-Abgleich, PV-009 GAP-2).
  // DEFAULT [] (nicht required), damit bereits persistierte `previewed`-Runs, deren
  // jsonb-Payload dieses Feld noch nicht enthält, beim Commit weiterhin sauber parsen.
  assignee_emails: z.array(z.string()).default([]),
});
export type PlannerImportChange = z.infer<typeof PlannerImportChangeSchema>;

export const PlannerImportPreviewResponseSchema = z.object({
  run_id: z.string().uuid(),
  total_rows: z.number().int(),
  changes: z.array(PlannerImportChangeSchema),
  log: z.array(PlannerImportLogEntrySchema),
});
export type PlannerImportPreviewResponse = z.infer<typeof PlannerImportPreviewResponseSchema>;

export const PlannerImportCommitRequestSchema = z.object({
  run_id: z.string().uuid(),
});
export type PlannerImportCommitRequest = z.infer<typeof PlannerImportCommitRequestSchema>;

export const PlannerImportCommitResponseSchema = z.object({
  run_id: z.string().uuid(),
  processed_count: z.number().int(),
  skipped_count: z.number().int(),
  log: z.array(PlannerImportLogEntrySchema),
});
export type PlannerImportCommitResponse = z.infer<typeof PlannerImportCommitResponseSchema>;

export const PlannerImportRunSummarySchema = z.object({
  run_id: z.string().uuid(),
  file_name: z.string(),
  uploaded_at: z.string(),
  status: z.enum(['previewed', 'committed']),
  total_rows: z.number().int(),
  processed_count: z.number().int().nullable(),
  skipped_count: z.number().int().nullable(),
});
export type PlannerImportRunSummary = z.infer<typeof PlannerImportRunSummarySchema>;

export const PlannerImportRunDetailSchema = PlannerImportRunSummarySchema.extend({
  log: z.array(PlannerImportLogEntrySchema),
});
export type PlannerImportRunDetail = z.infer<typeof PlannerImportRunDetailSchema>;
